var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / filter / go") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C13.1045695,-2.02906125e-16 14,0.8954305 14,2 L14,12.160179 C14,13.2647485 13.1045695,14.160179 12,14.160179 L11.855,14.16 L12.4421132,17.0937437 L1.44211325,17.0937437 L2.029,14.16 L2,14.160179 C0.8954305,14.160179 1.3527075e-16,13.2647485 0,12.160179 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L12,0 Z M4.02399836,10.2539227 C3.45845968,10.2539227 3,10.701638 3,11.2539227 C3,11.8062075 3.45845968,12.2539227 4.02399836,12.2539227 C4.58953703,12.2539227 5.04799671,11.8062075 5.04799671,11.2539227 C5.04799671,10.701638 4.58953703,10.2539227 4.02399836,10.2539227 Z M10.5239984,10.2539227 C9.95845968,10.2539227 9.5,10.701638 9.5,11.2539227 C9.5,11.8062075 9.95845968,12.2539227 10.5239984,12.2539227 C11.089537,12.2539227 11.5479967,11.8062075 11.5479967,11.2539227 C11.5479967,10.701638 11.089537,10.2539227 10.5239984,10.2539227 Z M12.7,3.90625627 L1.5,3.90625627 L1.5,9.27735864 L12.7,9.27735864 L12.7,3.90625627 Z M9.86757695,1.4648461 L4.33242305,1.4648461 C3.92791697,1.4648461 3.6,1.79276307 3.6,2.19726915 C3.6,2.56806639 3.87554134,2.8745075 4.23303758,2.92300604 L4.33242305,2.9296922 L9.86757695,2.9296922 C10.272083,2.9296922 10.6,2.60177523 10.6,2.19726915 C10.6,1.79276307 10.272083,1.4648461 9.86757695,1.4648461 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-filter-/-go",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Go",
    transform: "translate(2.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "currentColor",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGo);
export default __webpack_public_path__ + "static/media/go.5c1c16096105fd643ec32fdb4fdbb5c1.svg";
export { ForwardRef as ReactComponent };